import { getPrice } from "./index.js";
export function getDiscount(price, wasPrice) {
    if (!wasPrice || price >= wasPrice)
        return undefined;
    return Math.abs(Math.floor(((price - wasPrice) / wasPrice) * 100));
}
export function getDiscountFromPrices(prices, paymentFrequency) {
    const price = getPrice(prices, "DEFAULT", paymentFrequency);
    const priceWas = getPrice(prices, "WAS", paymentFrequency);
    return price?.amount
        ? getDiscount(price.amount, priceWas?.amount)
        : undefined;
}
